import { render, staticRenderFns } from "./ConfirmationAndInfoBox.vue?vue&type=template&id=15750848&scoped=true&"
import script from "./ConfirmationAndInfoBox.vue?vue&type=script&lang=js&"
export * from "./ConfirmationAndInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationAndInfoBox.vue?vue&type=style&index=0&id=15750848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15750848",
  null
  
)

export default component.exports